import { render, staticRenderFns } from "./EvaluationList.vue?vue&type=template&id=172d1554"
import script from "./EvaluationList.vue?vue&type=script&lang=js"
export * from "./EvaluationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports